import React from 'react';
import './BuildersPlaque.css';

export default function BuildersPlaque() {
  return (
    <div className="builders-plaque">
      Built in<br />
      the year 2025<br />
      by danbos
    </div>
  );
}
